export default __webpack_public_path__ + "static/media/Believer's Gauntlets of the Bloody Stone.ce7f9c44.jpg";